import { Icon } from "../Icon/Icon";
export const BlockButton = ({
	size,
	children,
	type,
	disabled,
	icon,
	loadingIcon,
	onClick = () => {},
	loading,
	fillLabel = false,
	width = "343px", // Default to 343px if no width is provided
}) => {
	const baseClassName = `flex px-3 py-4 flex-[1,0,0] h-[48px] justify-center items-center ${children ? "gap-2" : ""} rounded-lg overflow-hidden box-border`;

	const getTypeClass = () => {
		if (disabled) {
			switch (type) {
				case "Primary":
					return "bg-color_background_primary_2 text-white cursor-not-allowed";
				case "Secondary":
					return "bg-color_background_grey_2 text-white cursor-not-allowed";
				case "Critical":
					return "bg-color_background_negative_3 text-white cursor-not-allowed";
				case "Tertiary":
					return "bg-color-White text-color_text_primary_1 cursor-not-allowed";
				case "Critical Status":
					return "bg-color-White text-color_text_negative_3 hover:bg-color_background_negative_2 active:bg-color_background_negative_3";
				default:
					return "bg-color-White text-color_text_primary_1 cursor-not-allowed";
			}
		} else {
			switch (type) {
				case "Primary":
					return "bg-color_background_primary_3 text-white hover:bg-color_background_primary_4 active:bg-color_background_primary_5";
				case "Secondary":
					return "bg-color_background_grey_1 text-color_text_grey_5 hover:bg-color_background_grey_2 active:bg-color_background_grey_3";
				case "Critical":
					return "bg-color_background_negative_3 text-white hover:bg-color_background_negative_4 active:bg-color_background_negative_5";
				case "Tertiary":
					return "bg-color-White text-color_text_primary_3 hover:bg-color_background_grey_1 active:bg-color_background_grey_2";
				case "Critical Status":
					return "bg-color-White text-color_text_negative_3 hover:bg-color_background_negative_2 active:bg-color_background_negative_3";
				default:
					return "bg-White text-color_text_primary_3 hover:bg-color_background_grey_1 active:bg-color_background_grey_2";
			}
		}
	};
	const buttonSize =
		size === "Large"
			? "ButtonL"
			: size === "Medium"
				? "ButtonM"
				: size === "Small"
					? "ButtonS"
					: "ButtonL";

	return (
		<button
			className={`${baseClassName} ${getTypeClass()}`}
			style={{
				width: width,
				borderRadius: "8px",
			}}
			disabled={disabled || loading}
			onClick={onClick}
		>
			{icon && !loading && <Icon iconName={icon} size={size} />}
			{/* passing loading state to Icon */}
			{loading && loadingIcon && (
				<Icon iconName={loadingIcon} size={size} loading={loading} />
			)}
			{!loading && (
				<div className={`${buttonSize} ${fillLabel ? "flex-1" : ""}`}>
					{children}
				</div>
			)}
		</button>
	);
};
